import { render } from "./TemplateButtons.vue?vue&type=template&id=32a8806c&scoped=true"
import script from "./TemplateButtons.vue?vue&type=script&lang=ts"
export * from "./TemplateButtons.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-32a8806c"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QMenu,QList,QItem,QItemSection});qInstall(script, 'directives', {ClosePopup});
